import { render } from "./CocktailsFilterModal.vue?vue&type=template&id=3fb38d2c"
import script from "./CocktailsFilterModal.vue?vue&type=script&lang=js"
export * from "./CocktailsFilterModal.vue?vue&type=script&lang=js"

import "./CocktailsFilterModal.vue?vue&type=style&index=0&id=3fb38d2c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__